import { observer } from "mobx-react-lite"

import { DesktopView } from "@/domains/liquidity-page/components/liquidity-table-params/desktop-view"
import { MobileView } from "@/domains/liquidity-page/components/liquidity-table-params/mobile-view"
import { TabletView } from "@/domains/liquidity-page/components/liquidity-table-params/tablet-view"
import { useResponsive } from "@/hooks/use-responsive"

export const LiquidityTableParams = observer(() => {
  const { isMobile, isTablet, isDesktop } = useResponsive()

  if (isMobile) {
    return <MobileView />
  }
  if (isTablet) {
    return <TabletView />
  }
  if (isDesktop) {
    return <DesktopView />
  }
  return null
})
